import { get,  } from './request';
import { useQuery } from '@tanstack/react-query';


export enum ConfigKeysEnum {
  LINK_POWER_BI = 'LINK_POWER_BI',
  OPERATIONAL_BI_LINK = 'OPERATIONAL_BI_LINK',
  ACCESS_OPERATIONAL_EMAILS = 'ACCESS_OPERATIONAL_EMAILS',
  POTTENCIAL_REGISTER_BIOMETRICS_URL = 'POTTENCIAL_REGISTER_BIOMETRICS_URL'
}

export type ConfigKeyResponse = {
  success: boolean;
  key: ConfigKeysEnum;
  value: string;
  context: string;
}

async function fetchConfigKey(key: ConfigKeysEnum): Promise<ConfigKeyResponse> {
  try {
    const response = await get(`/config-keys/${key}`);
    return response;
  }catch(err) {
    return {
      success: false,
      key,
      value: '',
      context: ''
    };
  }
}

export function useConfigKey(key: ConfigKeysEnum) {
  return useQuery(
    ['configKey', key],
    () => fetchConfigKey(key), 
    {
      cacheTime: 1000 * 60 * 45  // 45 minutes
    }
  );
}
